import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    name: {
      label: {
        id: 'properties.name',
        defaultMessage: 'Name',
        description: 'Label of the field name',
      },
    },
    credentials: {
      label: {
        id: 'properties.credentials',
        defaultMessage: 'Credentials',
        description: 'Label of the field credentials',
      },
    },
    configuration: {
      label: {
        id: 'properties.configuration',
        defaultMessage: 'Configuration',
        description: 'Label of the field configuration',
      },
    },
  },
  properties: {
    delisId: {
      id: 'properties.delisId',
      defaultMessage: 'Delis ID',
      description: 'label of the delis id field',
    },
    host: {
      id: 'properties.host',
      defaultMessage: 'Host',
      description: 'label of the host field',
    },
    isPassive: {
      id: 'properties.isPassive',
      defaultMessage: 'Passive',
      description: 'label of the is passive field',
    },
    isSecure: {
      id: 'properties.isSecure',
      defaultMessage: 'Secure',
      description: 'label of the is secure field',
    },
    port: {
      id: 'properties.port',
      defaultMessage: 'Port',
      description: 'label of the port field',
    },
    root: {
      id: 'properties.root',
      defaultMessage: 'Root folder',
      description: 'label of the root field',
    },
    username: {
      id: 'properties.username',
      defaultMessage: 'Username',
      description: 'label of the username field',
    },
    password: {
      id: 'properties.password',
      defaultMessage: 'Password',
      description: 'label of the password field',
    },
    recaptchaSiteKey: {
      id: 'properties.recaptchaSiteKey',
      defaultMessage: 'Recaptcha site key',
      description: 'label of the recaptcha site key field',
    },
    recaptchaSecret: {
      id: 'properties.recaptchaSecret',
      defaultMessage: 'Recaptcha secret',
      description: 'label of the recaptcha secret field',
    },
    countryCode: {
      id: 'properties.countryCode',
      defaultMessage: 'Country code',
      description: 'label of the country code field',
    },
    secret: {
      id: 'properties.secret',
      defaultMessage: 'Secret',
      description: 'label of the secret field',
    },
    serviceId: {
      id: 'properties.serviceId',
      defaultMessage: 'Service ID',
      description: 'label of the service id field',
    },
    clientId: {
      id: 'properties.clientId',
      defaultMessage: 'Client ID',
      description: 'label of the client id field',
    },
    externalServiceId: {
      id: 'properties.externalServiceId',
      defaultMessage: 'External service ID',
      description: 'label of the external service id field',
    },
    bolShippingMethod: {
      id: 'properties.bolShippingMethod',
      defaultMessage: 'Bol.com shipping method',
      description: 'label of the bol.com shipping method field',
    },
    shippingMethod: {
      id: 'properties.shippingMethod',
      defaultMessage: 'Shipping method',
      description: 'label of the shipping method field',
    },
    shippingMethods: {
      id: 'properties.shippingMethods',
      defaultMessage: 'Shipping methods',
      description: 'label of the shipping methods field',
    },
    defaultShippingMethod: {
      id: 'properties.defaultShippingMethod',
      defaultMessage: 'Default shipping method',
      description: 'label of the default shipping method field',
    },
    apiKey: {
      id: 'properties.apiKey',
      defaultMessage: 'Api key',
      description: 'label of the api key field',
    },
    apiToken: {
      id: 'properties.apiToken',
      defaultMessage: 'Api token',
      description: 'label of the api token field',
    },
    tokenCode: {
      id: 'properties.tokenCode',
      defaultMessage: 'Token code',
      description: 'label of the token code field',
    },
    oauthClientKey: {
      id: 'properties.oauthClientKey',
      defaultMessage: 'Oauth client key',
      description: 'label of the oauth client key field',
    },
    channel: {
      id: 'properties.channel',
      defaultMessage: 'Channel',
      description: 'label of the channel field',
    },
    slackChannel: {
      id: 'properties.slackChannel',
      defaultMessage: 'Slack channel',
      description: 'label of the slack channel field',
    },
    webhookUrl: {
      id: 'properties.webhookUrl',
      defaultMessage: 'Webhook url',
      description: 'label of the webhook url field',
    },
    shopctrlUrl: {
      id: 'properties.shopctrlUrl',
      defaultMessage: 'ShopCtrl url',
      description: 'label of the shopctrl url field',
    },
    afostoCmsShippingMethod: {
      id: 'properties.afostoCmsShippingMethod',
      defaultMessage: 'Afosto 2.0 shipping method',
      description: 'label of the afosto cms shipping method field',
    },
    defaultShippingAddress: {
      id: 'properties.defaultShippingAddress',
      defaultMessage: 'Default shipping address ID',
      description: 'label of the afosto cms default shipping address field',
    },
    spid: {
      id: 'properties.spid',
      defaultMessage: 'Service point',
      description: 'label of the afosto cms service point field',
    },
    spidHelperText: {
      id: 'pages.integrations.integrationForm.fields.spid.helperText',
      defaultMessage: "Only select one if shipping method is 'pickup_up' by 'tenant'",
      description: 'helper text of the afosto cms service point field',
    },
  },
};

export default defineMessages(translations);
